export default {
    methods: {
        getGenderName(gender) {
            switch (gender) {
                case 'male':
                    return 'M'
                case 'female':
                    return 'F'
                case 'unknown':
                    return 'U'
                default:
                    return null
            }
        },

        getGenderClass(gender) {
            switch (gender) {
                case 'male':
                    return 'gender-male'
                case 'female':
                    return 'gender-female'
                case 'unknown':
                    return 'gender-unknown'
                default:
                    return null
            }
        },

        getVoiceName(voice) {
            // Remove parenthesis and its contents
            const name = voice.name.replace(/\s*\([^)]*\)/, '')
            return name
        },

        getAccent(accent) {
            if (!accent) {
                return null
            }
            return this.$options.filters.ucfirst(accent)
        },

        getLanguage(language) {
            if (!language) {
                return null
            }

            switch (language) {
                case 'en':
                    return 'English'
                case 'es':
                    return 'Spanish'
                default:
                    return null
            }
        },
        
        getFormattedVoiceLabel(voice) {
            let label = this.getVoiceName(voice)
            
            // Add language and accent if available
            if (this.getLanguage(voice.language)) {
                label += ' - ' + this.getLanguage(voice.language)
                
                if (this.getAccent(voice.accent)) {
                    label += ' (' + this.getAccent(voice.accent) + ')'
                }
            }
            
            return label
        }
    }
} 
